const defaultPreviewImageUrl =
  'https://www.jabra.com/-/media/F45399F075BE45A48A0EDEB5F8CF95B6.ashx';

export const groupEngravingImageMapping: { ids: number[]; imageId: string }[] = [
  {
    // 85t Titanium black
    ids: [1672, 1673, 1674, 1675, 1676, 1685],
    imageId: 'F45399F075BE45A48A0EDEB5F8CF95B6',
  },
  {
    // 75t Titanium black
    ids: [1489, 1620, 1519, 1491, 1621, 1640, 1677, 1503, 1617],
    imageId: 'A628D8B1CF0641A99215C1CF7F8ED0F8',
  },
  {
    // 75t Copper black
    ids: [1515],
    imageId: '1A2DD0709945447696C02657869F5EC3',
  },
  {
    // 75t Gold beige
    ids: [1493, 1504],
    imageId: '7DAC638B8189408F9D3749E61EC1C405',
  },
  {
    // 75t Grey
    ids: [1518, 1623, 1643, 1619],
    imageId: '7CD3D1402C0E405BAC2AB308EF4E32BB',
  },
  {
    // 75t Mint
    ids: [1516, 1641],
    imageId: '60DFA93919094C3FA2ADDF1AE021D346',
  },
  {
    // 75t Navy
    ids: [1514, 1622, 1639, 1618],
    imageId: '1B8BF4C7B4A04DD5A637E6DA97F12350',
  },
  {
    // 75t Sienna
    ids: [1517, 1642],
    imageId: '997A221B2E9549FD927D7EC947AF302B',
  },
];

export const getEngravingPreviewImageUrl = (groupId: number): string | undefined => {
  const imageId: string | undefined = groupEngravingImageMapping.find(
    (x) => x.ids.indexOf(groupId) > -1
  )?.imageId;
  if (!imageId) {
    return defaultPreviewImageUrl;
  }

  return `https://www.jabra.com/-/media/${imageId}.png`;
};
